/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { YearNavigationHeader } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/components/YearNavigationHeader';
import { Kalender } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/Kalender';
import { useNavigate, useParams } from 'react-router-dom';
import { useStandortgruppe } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useStandortgruppen/useRotationsplanAktiviert';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { managerV1BaseUrl } from '@/utils';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

const NavigateToV1 = () => {
  useEffect(() => {
    window.location.replace(managerV1BaseUrl);
  }, []);
  return <></>;
};

function validateRouteParam(view: string): boolean {
  const validViews: View[] = ['planung', 'rotationsplaene'];
  return validViews.includes(view as View);
}

export function Page() {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { standortGruppe } = useStandortgruppe(
    currentStandort.idStandortgruppe,
  );
  const { view, year } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if ((!view || !validateRouteParam(view)) && !year) {
      const currentYear = dayjs(new Date()).get('year');
      navigate(`/mitarbeiter/rotationsplan/${currentYear}/planung`, {
        replace: true,
      });
    } else if (!view || !validateRouteParam(view)) {
      navigate(`/mitarbeiter/rotationsplan/${year}/planung`, {
        replace: true,
      });
    } else if (!year) {
      const currentYear = dayjs(new Date()).get('year');
      navigate(`/mitarbeiter/rotationsplan/${currentYear}/${view}`, {
        replace: true,
      });
    }
  }, [navigate, view, year]);

  if (!standortGruppe || !standortGruppe.istRotationsplanAktiviert) {
    return <NavigateToV1 />;
  }

  return (
    <>
      <Helmet>
        <title>{t('domain.mitarbeiter.rotationsplan.title')}</title>
      </Helmet>
      <div className="flex flex-col gap-8">
        <Tabs
          value={view}
          onValueChange={(value) => {
            navigate(`/mitarbeiter/rotationsplan/${year}/${value}`);
          }}>
          <div className="flex w-full justify-between">
            <TabsList className="bg-neutrals-N300 w-full md:w-auto">
              <TabsTrigger className="w-full md:w-auto" value="planung">
                {t('domain.mitarbeiter.rotationsplan.tabs.planung')}
              </TabsTrigger>
              <TabsTrigger
                disabled
                className="w-full md:w-auto"
                value="rotationsplaene">
                {t('domain.mitarbeiter.rotationsplan.tabs.rotationsplaene')}
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent className="mt-8" value="planung">
            <div className="flex flex-col gap-4 w-full min-h-[500px] bg-white rounded-md items-start justify-start p-4">
              <YearNavigationHeader jahr={year} view={view as View} />
              <Kalender key={year} jahr={year} />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
}
